// extracted by mini-css-extract-plugin
export default {"ModalButton":"Modal_ModalButton__MYONw"};